import { Skeleton, Stack } from '@mui/material';
import React from 'react';

function GroupSwitcherSkeleton() {
  return (
    <Stack alignItems="center" direction="row" gap={1}>
      <Skeleton height={24} variant="circular" width={24} />
      <Skeleton height={16} variant="rounded" width={100} />
      <Skeleton height={16} variant="circular" width={16} />
      <Skeleton height={24} variant="circular" width={24} />
      <Skeleton height={16} variant="rounded" width={100} />
    </Stack>
  );
}

export default GroupSwitcherSkeleton;
